<template>
  <el-container id="timingTjcfSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:left;align-items:center;margin-left:40px">
          <span style="width:100px; margin-left:10px; color: #000000; font-size: 13px">
            约束条件名称：
          </span>
          <el-input
              placeholder="请输入约束条件名称"
              style="width:15vw;"
              clearable
              v-model="TimingName">
          </el-input>
        </div>
        <!--        <div-->
        <!--          style="display:flex;justify-content:left;align-items:center;margin-top:25px;margin-bottom:25px;margin-left:40px">-->
        <!--          <span style="width:100px;margin-left:10px; color: #000000; font-size: 13px">-->
        <!--            约束类型：-->
        <!--          </span>-->
        <!--          <el-radio-group v-model="xz_type">-->
        <!--            <el-radio :label=1>设备状态</el-radio>-->
        <!--            <el-radio :label=2>生效时段</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </div>-->
        <div v-if="xz_type===1"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:100px;margin-left:10px; color: #000000; font-size: 13px">
            选择设备：
          </span>
          <el-select v-model="edi_buildId" ref='select1' @change="getFloor('build')"
                     @visible-change='show_change1'
                     filterable placeholder="楼栋"
                     style="width:5vw;">
            <el-option
                v-for="item in li_build"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_floorId" ref='select2' @change="getFloor('floor')"
                     @visible-change='show_change2' @click.native="checkLd()"
                     clearable filterable placeholder="楼层"
                     style="width:5vw;margin-left:10px">
            <el-option
                v-for="item in li_floor"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_roomId" ref='select3' @click.native="checkLd()"
                     @visible-change='show_change3'
                     clearable filterable placeholder="房间"
                     style="width:5vw;margin-left:10px">
            <el-option
                v-for="item in li_room"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="xz_type===1"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:150px">
          <el-select v-model="edi_dev" ref='select' @change="change_dev" @click.native="onSelectDev"
                     filterable placeholder="请选择设备"
                     style="width:15vw;">
            <el-option
                v-for="item in fil_tabData"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="xz_type===1"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:100px;margin-left:10px; color: #000000; font-size: 13px">
            约束属性：
          </span>
          <div @click="xz_act"
               style="width:200px;height:25px;margin-left:0px;display:flex;justify-content:left;align-items:center;border: 1px solid #EFEFEF;padding: 5px;">
            <p style="padding-left:5px; color:#A0A0A0">{{ act }}</p>
            <p style="margin-left: auto;margin-right:5px;color: #1D66DD">设置</p>
          </div>
        </div>
        <div v-if="xz_type===2"
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:100px;margin-left:10px; color: #000000; font-size:13px">
            生效时段：
          </span>
          <el-time-select
              style="width:7vw;"
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59'
              }">
          </el-time-select>
          <el-time-select
              style="margin-left:15px;width:7vw;"
              placeholder="结束时间"
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59',
              }">
          </el-time-select>
        </div>
        <div>
          <div style="display:flex;justify-content:left;align-items:center;margin-top:50px;margin-left:150px">
            <el-button @click="onBack" size="medium">取消</el-button>
            <el-button @click="onKeep" size="medium" type="primary">保存</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog title='添加约束条件' center :close-on-click-modal="false"
               width="500px" height="600px" class="dialog_dev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddAct'> <!--v-draggable 拖动-->
      <div v-for="(d,index) in fil_li_ctl"
           style="display:flex;margin-bottom:10px;height:50px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <span style="margin-left:1vw; width:80px; color: #000000; font-size: 13px">
            {{ d.desc }}：
        </span>
        <el-select v-model="d.edi_type" ref='select10'
                   filterable placeholder="类型"
                   style="width:80px;">
          <el-option
              v-for="item in d.li_Type"
              :key="item.value"
              :disabled="d.is0pera"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select v-if="d.edi_type===1" v-model="d.edi_opera" ref='select10'
                   filterable placeholder="符号"
                   style="width:80px;margin-left:5px">
          <el-option
              v-for="item in d.li_opera"
              :key="item.value"
              :disabled="d.is0pera"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input-number v-else-if="d.type==='int'" size="medium" v-model="d.value1"
                         style="width:80px;margin-left:5px" :controls="false"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max)>
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'" size="medium" v-model="d.value1"
                         style="width:80px;margin-left:5px" :controls="false"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)>
        </el-input-number>
        <p v-if="d.edi_type===2" style="margin-left:5px">-</p>
        <p v-else style="margin-left:7px"></p>
        <el-select v-if="d.type==='enum'" v-model="d.value" ref='select4'
                   filterable placeholder="设备状态"
                   style="width:80px;margin-left:5px">
          <el-option
              v-for="item in d.li_d"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input-number v-else-if="d.type==='int'" size="medium" v-model="d.value"
                         style="width:80px;margin-left:5px" :controls="false"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max)>
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'" size="medium" v-model="d.value"
                         style="width:80px;margin-left:5px" :controls="false"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)>
        </el-input-number>
        <span v-else style="margin-left:1vw; width:120px; color: #000000; font-size: 13px">
            {{ d.value }}
        </span>
        <el-checkbox v-model="checkboxes[index]" @change="handleChange(index)"
                     style="margin-left:10px"></el-checkbox>
      </div>
      <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                        text-align:left;align-items:center;">
        <el-button @click="dialog_act('退出')" style="margin-left: auto">取消</el-button>
        <el-button @click="dialog_act('保存')" type="primary">保存</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>

export default {
  name:"timingTjcfSon",
  data() {
    return {
      is_ble:false,
      h_text:"新增约束条件",
      li_h_text:[
        {"text":"联动策略","colour":"#B7B7B7","pages":""},
        {"text":"约束条件","colour":"#B7B7B7","pages":""}
      ],
      isCtr:true,
      pageAll:1,
      pageSizeAll:30,
      totalAll:30,
      startTime:"",
      endTime:"",
      times:new Date(),
      rqS:[
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "日"
      ],
      check_rqS:[
        "一",
        "二",
        "三",
        "四",
        "五"
      ],
      checkAll:false,
      isIndeterminate:false,
      id:"",
      edi_dev:"",
      li_dev:[],
      edi_val:"",
      li_val:[
        {
          value:1,
          label:'开启'
        },
        {
          value:0,
          label:'关闭'
        }
      ],
      li_dev_xz:[],
      TimingName:"",
      passWd:"",
      nickName:"", /*账号*/
      li_build:[],
      edi_buildId:"",
      li_floor:[],
      edi_floorId:"",
      li_room:[],
      edi_roomId:"",
      act:"约束值",
      cmd:"",
      dataType:"",
      pid:"",
      xz_type:1,
      li_ctl:[],
      daiAddAct:false,
      checkboxes:[],
      tabData:[]
    };
  },
  methods:{ /*方法存放*/
    handleChange(i) {
      this.checkIndex = i;
      this.checkboxes = this.checkboxes.map((val,index) => index === i);
    },
    onSelectDev() {
      console.log("点击下拉框触发");
      this.getDev();
    },
    xz_act() {
      if (!this.edi_dev) {
        this.$message.error("请先选择设备");
        return;
      }
      let pid = "";
      const d = this.fil_tabData.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['did'] === this.edi_dev;
      });
      if (d !== undefined) {
        pid = d["pid"];
      }
      if (pid) {
        this.getPidArg(pid,this.cmd);
      } else {
        this.getPidArg(this.pid,this.cmd);
      }
      this.daiAddAct = true;
    },
    change_dev(v) {
      console.log(v);
      let d = this.tabData.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['did'] === this.did;
      });
      if (d !== undefined) {
        this.pid = d['pid'];
      }
      console.log(this.pid);
      this.act = "约束值";
      this.cmd = "";
    },
    addDev() {
      if (this.li_dev_xz.length > 0) {
        this.li_dev_xz.push({
          id:this.li_dev_xz[this.li_dev_xz.length - 1]["id"] + 1,
          edi_dev:""
        });
      } else {
        this.li_dev_xz.push({
          id:0,
          edi_dev:""
        });
      }
    },
    del_dev(id) {
      const index = this.li_dev_xz.findIndex(item => item.id === id);
      this.li_dev_xz.splice(index,1);
    },
    checksChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.rqS.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
    },
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item) {
      if (item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    onKeep() {
      if (!this.cmd) {
        this.$message.warning("请先选择约束属性");
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '新增约束条件') {
          this.addTiming1();
        } else {
          this.changeTiming();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    addTiming1() {
      let cmd = JSON.parse(this.cmd);
      const params = {
        'name':this.TimingName,
        'dataType':this.dataType,
        'did':this.edi_dev,
        'identifier':cmd["identifier"], /*参数名*/
        'identifierName':cmd["identifierName"],/*参数中文*/
        'valueType':cmd["valueType"], /* 1:目标 2:区间"*/
        'opera':cmd["opera"], /*运算符*/
        'targetValue':"" + cmd["targetValue"], /*参数目标值*/
        'fromValue':"" + cmd["fromValue"], /*区间值1*/
        'toValue':"" + cmd["toValue"], /*区间值2*/
        'valueName':this.act, /*显示名称*/
        'projectId':localStorage.getItem("projectId")
      };
      if (cmd["valueType"] === 2) {
        params["fromValue"] = cmd["value1"];  /*value1在前*/
        params["toValue"] = cmd["value"];
      } else {
        params["targetValue"] = cmd["value"];
      }
      const d = this.fil_tabData.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['did'] === this.edi_dev;
      });
      if (d !== undefined) {
        params["pid"] = d["pid"];
        params["devName"] = d["devName"];
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addAutoCondition,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加失败");
        }
      });
    },
    changeTiming() {
      console.log(this.id);
      let cmd = JSON.parse(this.cmd);
      console.log("cmd：",cmd);
      const params = {
        'id':this.id,
        'name':this.TimingName,
        'dataType':this.dataType,
        'did':this.edi_dev,
        'identifier':cmd["identifier"], /*参数名*/
        'identifierName':cmd["identifierName"],/*参数中文*/
        'valueType':cmd["valueType"], /* 1:目标 2:区间"*/
        'opera':cmd["opera"], /*运算符*/
        'targetValue':"" + cmd["targetValue"], /*参数目标值*/
        'fromValue':"" + cmd["fromValue"], /*区间值1*/
        'toValue':"" + cmd["toValue"], /*区间值2*/
        'valueName':this.act, /*显示名称*/
        'projectId':localStorage.getItem("projectId")
      };
      const d = this.fil_tabData.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['did'] === this.edi_dev;
      });
      if (d !== undefined) {
        params["pid"] = d["pid"];
        params["devName"] = d["devName"];
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateAutoCondition,params,headers).then(res => {
        console.log("re_d",res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      this.$router.go(-1);
    },
    initView(area_type = "") {
      let l = [];
      let isCleanF = true;
      let isCleanR = true;
      let l_d = this.li_buildInfo;
      for (let i = 0; i < l_d.length; i++) {
        let d = {
          value:l_d[i]['id'],
          label:l_d[i]['name']
        };
        if (this.edi_floorId === l_d[i]['id']) {
          isCleanF = false;
        }
        l.push(d);
      }
      this.li_floor = l;
      l = [];
      for (let j = 0; j < l_d.length; j++) {
        if (this.edi_floorId && l_d[j]['id'] !== this.edi_floorId) {
          continue;
        }
        for (let k = 0; k < l_d[j]['rooms'].length; k++) {
          let d = {
            value:l_d[j]['rooms'][k]['id'],
            label:l_d[j]['rooms'][k]['name']
          };
          if (this.edi_roomId === l_d[j]['rooms'][k]['id']) {
            isCleanR = false;
          }
          l.push(d);
        }
      }
      this.li_room = l;
      if (isCleanF) {
        this.edi_floorId = "";
      }
      if (isCleanR) {
        this.edi_roomId = "";
      }
    },
    initDev() {
      let data = this.li_dev;
      let li_d = [];
      let li_a = []; /*区域*/
      let j = 1;
      for (let i = 0; i < data.length; i++) {
        let d = {
          value:data[i]['did'],
          label:data[i]['name'],
          item:j,
          did:data[i]['did'],
          pid:data[i]['pid'],
          devName:data[i]['name'],
          devMac:data[i]['did'],
          stateId:data[i]['stateId'],
          roomId:data[i]['roomId']
        };
        if (data[i]['roomId']) {
          d['floorId'] = data[i]['room']['floorId'];
          if (data[i]['room']['floor']) {
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            d['devArea'] = data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            if (data[i]['room']['floor']['building']) {
              d['devArea'] = data[i]['room']['floor']['building']['name'] + "-" + data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            }
          }
        } else if (data[i]['floorId']) {
          d['floorId'] = data[i]['floorId'];
          if (data[i]['floor']) {
            d['buildId'] = data[i]['floor']['buildingId'];
            d['devArea'] = data[i]['floor']['name'];
            if (data[i]['floor']['building']) {
              d['devArea'] = data[i]['floor']['building']['name'] + "-" + data[i]['floor']['name'];
            }
          }
        }
        // let exists = li_a.some(dict => dict.value === d['devArea']); /*筛选字典数组*/
        // if (!exists) {
        //   li_a.push({value: d['devArea'], label: d['devArea']})
        // }
        // const aliceItems = this.li_pid.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        //   return fruit['value'] === d.pid;
        // })
        // if (aliceItems !== undefined) {
        //   d["devType"] = aliceItems["label"];
        // }
        // if (!d["stateId"]) {
        //   d["stateId"] = 2
        //   d["devState"] = "离线"
        // } else {
        //   const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        //     return fruit['value'] === d.stateId;
        //   })
        //   if (state !== undefined) {
        //     d["devState"] = state["label"];
        //   }
        // }
        li_d.push(d);
        j += 1;
      }
      // this.li_xz_area = li_a
      this.tabData = li_d;
    },
    getDev() {
      this.getDevdata();
    },
    getDevdata() {
      if (this.pageAll < this.totalAll / this.pageSizeAll + 1) {
        const params = {
          'page':this.pageAll,
          'pageSize':this.pageSizeAll,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log("getDeviceList",params);
        this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalAll = res.data.data.total;
          const l_d = this.li_dev;
          for (let i = 0; i < res.data.data["list"].length; i++) {
            l_d.push(res.data.data["list"][i]);
          }
          this.li_dev = l_d;
          this.pageAll += 1;
          this.getDevdata();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("获取设备信息失败");
          }
        });
      } else {
        this.isDev = true;
        this.initDev();
      }
    },
    getPidArg(pid,cmd) {
      let key1 = "";
      let val1 = "";
      let item = 0;
      const params = {
        'pid':pid
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getPidArg,params,headers).then(res => {
        console.log("pid参数",res.data.data);
        let data = res.data.data["iotPidProfile"]["properities"];
        console.log("data",data);
        let l = [];
        if (cmd) { /*当命令为真时再解析*/
          cmd = JSON.parse(cmd);
        }
        for (let i = 0; i < data.length; i++) {
          let d = {
            "pid":pid,
            "name":data[i]['name'],
            "desc":data[i]['desc'],
            "type":data[i]["define"]['type'],
            "mode":data[i]['mode'],
            "value":"",
            "value1":0,
            "is0pera":true,  /*用于判断是否出现valueType*/
            "edi_type":1, /*1:目标 2:区间*/
            "li_Type":[
              {
                value:1,
                label:'目标'
              },
              {
                value:2,
                label:'区间'
              }
            ],
            "edi_opera":"EQ", /*LT(小于),LE(小于等于),EQ(等于),GT(大于),GE(大于等于)*/
            "li_opera":[
              {
                value:'LT',
                label:'<'
              },
              {
                value:'LE',
                label:'<='
              },
              {
                value:'EQ',
                label:'='
              },
              {
                value:'GT',
                label:'>'
              },
              {
                value:'GE',
                label:'>='
              }
            ]
          };
          if (d["mode"] === "r") {
            continue;
          }
          if (d['type'] === 'int' || d['type'] === 'float') {
            d["is0pera"] = false;
            d["step"] = parseInt(data[i]["define"]["step"]);
            d["min"] = parseInt(data[i]["define"]["min"]);
            d["max"] = parseInt(data[i]["define"]["max"]);
          } else if (d['type'] === 'enum') {
            let l1 = [];
            for (let j = 0; j < data[i]["define"]["mapping"].length; j++) {
              l1.push({
                "label":data[i]["define"]["mapping"][j]["desc"],
                "value":parseInt(data[i]["define"]["mapping"][j]["value"])
              });
            }
            d["li_d"] = l1;
            d["value"] = parseInt(l1[0]["value"]);
            d["value1"] = parseInt(l1[0]["value"]);
          } else { /*字符串*/
            d["value"] = data[i]['name'];
          }
          if (cmd) { /*当命令为真时再解析-初始化选中值*/
            if (d['name'] === cmd["identifier"]) {
              key1 = cmd["identifier"];
              d["edi_type"] = cmd["valueType"];
              d["edi_opera"] = cmd["opera"];
              if (d["edi_type"] === 1) {
                d["value"] = cmd["targetValue"];
              } else {
                d["value1"] = cmd["fromValue"];  /*value1在前*/
                d["value"] = cmd["toValue"];
              }
              item = i;
              console.log("start_cmd",d);
            }
          }
          l.push(d);
        }
        this.li_ctl = l;
        let checkboxes = [];
        for (let i = 0; i < this.li_ctl.length; i++) {
          checkboxes.push(false);
        }
        this.checkboxes = checkboxes;
        this.handleChange(item);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    dialog_act(v) {
      switch (v) {
        case "保存":
          // if (!this.fil_li_ctl[this.checkIndex]["value"]) {
          //   this.$message.error("请先选择参数值")
          //   return
          // }
          this.dataType = this.fil_li_ctl[this.checkIndex]["type"];
          let cat_name = this.fil_li_ctl[this.checkIndex]["name"]; /*参数*/
          let desc = this.fil_li_ctl[this.checkIndex]["desc"]; /*参数中文*/
          let cat_val = this.fil_li_ctl[this.checkIndex]["value"];  /*选中值*/
          let cat_val1 = this.fil_li_ctl[this.checkIndex]["value1"];
          let txt_val = this.fil_li_ctl[this.checkIndex]["value"];
          let is0pera = this.fil_li_ctl[this.checkIndex]["is0pera"];
          let edi_type = this.fil_li_ctl[this.checkIndex]["edi_type"]; /*1 目标 2 区间*/
          let edi_opera = this.fil_li_ctl[this.checkIndex]["edi_opera"]; /*LT(小于),LE(小于等于),EQ(等于),GT(大于),GE(大于等于)*/
          let d = { /*cmd*/
            "identifier":cat_name, /*参数名*/
            "identifierName":desc, /*参数中文*/
            "valueType":edi_type,
            "opera":edi_opera,
            "targetValue":cat_val,
            "fromValue":"", /*区间值1*/
            "toValue":"", /*区间值2*/
            "valueName":"", /*名称*/
            "targetName":""/*名称*/
          };
          console.log("----",this.fil_li_ctl[this.checkIndex]);
          if (edi_type === 2) { /*区间*/
            let value1 = cat_val1;
            let value2 = cat_val;
            if (cat_val1 > cat_val) {
              value1 = cat_val;
              value2 = cat_val1;
            }
            d["fromValue"] = value1;
            d["toValue"] = value2;
            this.act = `${desc}:${value1}-${value2}`;
          } else {
            if (this.fil_li_ctl[this.checkIndex]["type"] === "enum") {
              const d = this.fil_li_ctl[this.checkIndex]["li_d"].find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
                return fruit['value'] === cat_val;
              });
              if (d !== undefined) {
                txt_val = d["label"];
              }
            }
            let fh = "==";
            const d1 = this.fil_li_ctl[this.checkIndex]["li_opera"].find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return fruit['value'] === edi_opera;
            });
            if (d1 !== undefined) {
              fh = d1["label"];
            }
            this.act = `${desc}${fh}${txt_val}`;
          }
          this.cmd = JSON.stringify(d);
          this.daiAddAct = false;
          console.log("cmd",d);
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = '#283A4D';
          },300);
          this.daiAddAct = false; /*将dialog关闭*/
          break;
      }
    },
    checkLd() {
      if (!this.edi_buildId) {
        this.$message.info("请先选择楼栋");
      }
    },
    getFloor(area_type = "") {
      const params = {
        "page":1,
        "pageSize":1000,
        "id":this.li_area[this.item]['id'],
        "projectId":localStorage.getItem("projectId")
      };
      if (area_type === "build") {
        if (this.edi_buildId) {
          params["id"] = this.edi_buildId;
          const headers = {
            'token':localStorage.getItem("token")
          };
          this.$api.post(this.$urls.ip + this.$urls.getBuildingInfo,params,headers).then(res => {
            console.log("楼层：",res.data.data);
            this.li_buildInfo = res.data.data["floors"];
            this.initView(area_type);
          }).catch(error => {
            console.log(error);
            if (error) {
              this.$message.error("获取楼层数据失败");
            }
          });
        }
      } else if (area_type === "floor") {
        this.initView(area_type);
      }
    },
    getBuilding() {
      const params = {
        "page":1,
        "pageSize":1000,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_area = res.data.data.list;
        let l_d = this.li_area;
        let l = [];
        for (let i = 0; i < l_d.length; i++) {
          let d = {
            value:l_d[i]['id'],
            label:l_d[i]['name']
          };
          l.push(d);
        }
        this.li_build = l;
        this.item = 0;
        this.getFloor("build");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取区域失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    console.log(value);
    if (value === "add") {
      this.h_text = "新增约束条件";
    } else {
      this.h_text = "修改约束条件";
      this.id = parseInt(this.$route.query.id);
      this.TimingName = this.$route.query.name;
      this.pid = this.$route.query.pid;
      this.edi_dev = this.$route.query.did;
      this.devName = this.$route.query.devName;
      this.fil_tabData.push({
        'value':this.edi_dev,
        'label':this.devName,
        'did':this.edi_dev,
        'pid':this.pid,
        'devName':this.devName
      });
      this.act = this.$route.query.valueName;
      this.identifier = this.$route.query.identifier; /*执行参数*/
      this.dataType = this.$route.query.dataType; /*参数数据类型 int/string*/
      let d = {
        identifier:this.$route.query.identifier,
        identifierName:this.$route.query.identifierName,
        valueType:parseInt(this.$route.query.valueType),
        opera:this.$route.query.opera,
        targetValue:this.$route.query.targetValue, /*参数值*/
        fromValue:parseInt(this.$route.query.fromValue),
        toValue:parseInt(this.$route.query.toValue),
        valueName:this.$route.query.valueName,
        targetName:this.$route.query.targetName
      };
      if (this.dataType === 'int' || this.dataType === 'enum') {
        d["targetValue"] = parseInt(d["targetValue"]);
      } else if (this.dataType === 'float') {
        d["targetValue"] = parseFloat(d["targetValue"]);
      }
      this.cmd = JSON.stringify(d);
      console.log("cmd",d);
    }
    if (localStorage.getItem("is_ble_timing") === "1") {
      this.is_ble = true;
    } else {
      this.is_ble = false;
    }
    this.getBuilding();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        if (this.edi_buildId && item.buildId !== this.edi_buildId) {
          this.state = false;
        }
        if (this.edi_floorId && item.floorId !== this.edi_floorId) {
          this.state = false;
        }
        if (this.edi_roomId && item.roomId !== this.edi_roomId) {
          this.state = false;
        }
        return this.state;
      });
    },
    fil_li_ctl() {
      return this.li_ctl;
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#timingTjcfSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/scene/tlinkTjysSon.vue